module.exports = __webpack_public_path__ + "static/media/daniel-olahhOld.facbbdb7.jpg";